export default "__VITE_ASSET__DEEOVXVX__"